<template>

<j-modal
    title="选择部门"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    switchFullscreen
    cancelText="关闭">
    <a-spin tip="Loading..." :spinning="false">
      <a-card :loading="cardLoading" :bordered="false" style="height: 100%;">
    <a-spin :spinning="loading">
      <a-input-search v-show="false" @search="handleSearch" style="width:100%;margin-top: 10px" placeholder="输入机构名称查询..." enterButton />

      <!-- <a-tree
        showLine
        checkStrictly
        :selectedKeys="selectedKeys"
        :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
        :treeData="treeDataSource"
        default-expand-parent
        default-expand-all
        @select="handleTreeSelect"
        v-if="spinning"
      /> -->

      <a-tree
        class="my-dept-select-tree"
        checkable
        :treeData="treeDataSource"
        :checkStrictly="true"
        @check="onCheck"
        @expand="onExpand"
        :autoExpandParent="autoExpandParent"
        :expandedKeys="expandedKeys"
        :checkedKeys="checkedKeys">

        <template slot="title" slot-scope="{title}">
          <span v-if="title.indexOf(searchValue) > -1">
            {{title.substr(0, title.indexOf(searchValue))}}
            <span style="color: #f50">{{searchValue}}</span>
            {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
          </span>
          <span v-else>{{title}}</span>
        </template>
      </a-tree>
  
    </a-spin>
  </a-card>

    </a-spin>
</j-modal>
  
</template>

<script>
  import { queryDepartTreeList, searchByKeywords } from '@/api/api'

  export default {
    name: 'UserPhoneBindLeft',
    props:['modalWidth','multi','rootOpened','departId','value'],
    data() {
      return {
        cardLoading: true,
        loading: false,
        treeDataSource: [],
        selectedKeys: [],
        expandedKeys: [],
        user:{},
        spinning:false,
        bkdjArr:[],
        xzzzid:"",

        visible:false,
        confirmLoading:false,
        autoExpandParent:true,
        dataList:[],
        checkedKeys:[],
        checkedRows:[],
        searchValue:"",
        obj:{}
      }
    },
    created() {
      this.$nextTick(() => {
        this.user = this.$store.getters.userInfo;
        this.queryTreeData();

        
      })
    },
    methods: {

      queryTreeData(keyword) {
        this.commonRequestThen(queryDepartTreeList({
          departName: keyword ? keyword : undefined
        }))
      },

      handleSearch(value) {
        if (value) {
          this.commonRequestThen(searchByKeywords({ keyWord: value }))
        } else {
          this.queryTreeData()
        }
      },

      handleTreeSelect(selectedKeys, event) {
        if(this.bkdjArr.toString().indexOf(selectedKeys[0]) > -1){
          
        }else{
          if (selectedKeys.length > 0 && this.selectedKeys[0] !== selectedKeys[0]) {
            this.selectedKeys = [selectedKeys[0]]
            let orgCode = event.node.dataRef.orgCode
            this.emitInput(orgCode)
          }
        }
      },

      emitInput(orgCode) {
        this.$emit('input', orgCode)
      },

      commonRequestThen(promise) {
        this.loading = true
        promise.then(res => {
          if (res.success) {
            let dateList = this.sjcz(res.result,0);
            if(this.bkdjArr.length>=2){
              this.bkdjArr = this.bkdjArr.slice(0,this.bkdjArr.length-1);
            }
            
            this.treeDataSource = dateList;
            this.spinning = true;
            this.selectedKeys[0] = this.xzzzid;
            this.handleTreeSelect(this.selectedKeys, "select");
            
            // update-begin- --- author:wangshuai ------ date:20200102 ---- for:去除默认选中第一条数据、默认展开所有第一级
            // 默认选中第一条数据、默认展开所有第一级
            // if (res.result.length > 0) {
            //   this.expandedKeys = []
            //   res.result.forEach((item, index) => {
            //     if (index === 0) {
            //       this.selectedKeys = [item.id]
            //       this.emitInput(item.orgCode)
            //     }
            //     this.expandedKeys.push(item.id)
            //   })
            // }
           // update-end- --- author:wangshuai ------ date:20200102 ---- for:去除默认选中第一条数据、默认展开所有第一级
          } else {
            this.$message.warn(res.message)
            console.error('组织机构查询失败:', res)
          }
        }).finally(() => {
          this.loading = false
          this.cardLoading = false
        })
      },

      sjcz(lsit,num){
        var returnlist = [];
        for(var i=0;i<lsit.length;i++){
          if(lsit[i].orgCode==this.user.orgCode){
             this.xzzzid = lsit[i].id;
             returnlist.push(lsit[i]);
             return returnlist;
          }else{
            if(lsit[i].children!=null){
              if(lsit[i].orgCode.length < this.user.orgCode.length){
                this.bkdjArr.push(lsit[i].id);
                lsit[i].children = this.sjcz(lsit[i].children,num++);
                returnlist.push(lsit[i]);
                return returnlist;
              }
            }
          }
        }
      },

      getObj(keyid,lsit){
        var obj = null;
        if(lsit==null){
          return obj;
        }
        for(var i=0;i<lsit.length;i++){
          if(lsit[i].id==keyid){
            return lsit[i];
          }else{
            var oo = this.getObj(keyid,lsit[i].children);
            if(oo!=null){
              return oo;
            }
          }
        }
      },

      handleAdd: function () {
        this.$refs.modalForm.add(this.orgCode);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
      onCheck (checkedKeys,info) {
        var obj = this.getObj(checkedKeys.checked[checkedKeys.checked.length-1],this.treeDataSource);
        if(obj.orgCode.length<this.user.orgCode.length){
          checkedKeys.checked.splice(checkedKeys.checked.length-1,1);
          return;
        }
        if(!this.multi){
          let arr = checkedKeys.checked.filter(item => this.checkedKeys.indexOf(item) < 0)
          this.checkedKeys = [...arr]
          this.checkedRows = (this.checkedKeys.length === 0) ? [] : [info.node.dataRef]
        }else{
          this.checkedKeys = checkedKeys.checked
          this.checkedRows = this.getCheckedRows(this.checkedKeys)
        }


        var obj2 = this.getObj(checkedKeys.checked[checkedKeys.checked.length-1],this.treeDataSource);
        
        this.obj = obj2;
      },
      onSelect(selectedKeys,info) {
        let keys = []
        keys.push(selectedKeys[0])
        if(!this.checkedKeys || this.checkedKeys.length===0 || !this.multi){
          this.checkedKeys = [...keys]
          this.checkedRows=[info.node.dataRef]
        }else{
          let currKey = info.node.dataRef.key
          if(this.checkedKeys.indexOf(currKey)>=0){
            this.checkedKeys = this.checkedKeys.filter(item=> item !==currKey)
          }else{
            this.checkedKeys.push(...keys)
          }
        }
        this.checkedRows = this.getCheckedRows(this.checkedKeys)
      },
      onExpand (expandedKeys) {
        this.expandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      handleSubmit(){
        this.$emit('ok4',this.obj);
        this.visible = false;
      },
      handleCancel(){
        this.handleClear()
      },
      handleClear(){
        this.visible=false
        this.checkedKeys=[]
      },
      getParentKey(currKey,treeData){
        let parentKey
        for (let i = 0; i < treeData.length; i++) {
          const node = treeData[i]
          if (node.children) {
            if (node.children.some(item => item.key === currKey)) {
              parentKey = node.key
            } else if (this.getParentKey(currKey, node.children)) {
              parentKey = this.getParentKey(currKey, node.children)
            }
          }
        }
        return parentKey
      },
      onSearch(value){
        const expandedKeys = this.dataList.map((item) => {
          if (item.title.indexOf(value) > -1) {
            return this.getParentKey(item.key,this.treeData)
          }
          return null
        }).filter((item, i, self) => item && self.indexOf(item) === i)

        Object.assign(this, {
          expandedKeys,
          searchValue: value,
          autoExpandParent: true,
        })


      },
      // 根据 checkedKeys 获取 rows
      getCheckedRows(checkedKeys) {
        const forChildren = (list, key) => {
          for (let item of list) {
            if (item.id === key) {
              return item
            }
            if (item.children instanceof Array) {
              let value = forChildren(item.children, key)
              if (value != null) {
                return value
              }
            }
          }
          return null
        }

        let rows = []
        for (let key of checkedKeys) {
          let row = forChildren(this.treeData, key)
          if (row != null) {
            rows.push(row)
          }
        }
        return rows
      }
    }
  }
</script>

<style scoped>

</style>